<template lang="pug">
div
  v-dialog(
    v-model='isUploadAvatar',
    :max-width="isMovil ? '100%' : '50%'"
    transition='dialog-bottom-transition'
    :fullscreen="isMovil"
  )
    v-card
      adjuntar-archivos(
        @close="closeModalAdjuntar",
        ref="archivos",
        :multiple="false"
        v-if="isUploadAvatar",
        :extensions="['png', 'jpg', 'jpeg']",
        :accept="['image/*']"
        label="Elegir como perfil",
        @save="getImagenToProfile",
        :is-set-profile="true"
      )
  v-dialog(
    v-model='isActiveAccount'
    width="500",
    @click:outside="closeModalIsActiveAccount()",
    transition='dialog-bottom-transition'
  )
    v-card.pa-4
      h1.text-center.font-weight-700.font-size-25.py-2 Activar cuenta
      v-card-text
        span Verifica los datos y dale confirmar si realmente deseas aprobar la siguiente cuenta de Help Desk.
        strong.ml-3.primary--text {{usuario.razonSocial}}
      v-card-actions
        v-spacer
        v-btn(color='ligth' v-if="!isMovil" text=''  @click='closeModalIsActiveAccount()')
         small Cancelar
        v-btn(color='success' :loading="isLoadingActivating" :block ="isMovil" @click='fetchActivateAccount()')
         small Confirmar
  v-dialog(
    v-model='isSetPassword'
    width="500",
    @click:outside="closeModalSetPassword()",
    transition='dialog-bottom-transition'
  )
    v-card.pa-4
      h1.text-center.font-weight-700.font-size-20.py-2 {{!validar ? 'Ingresa la contraseña actual del usuario, para guardar los cambios realizados.' : 'Ingresa tu contraseña actual, para guardar los cambios realizados.'}}
      v-card-text
        v-text-field.pt-6(
          dense,
          hide-details
          v-model='currentPassword',
          :append-icon="!showPassword ? 'visibility' : 'visibility_off'",
          :type="showPassword ? 'text' : 'password'",
          label='Contraseña actual',
          @click:append='showPassword = !showPassword',
          ref="currentPassword"
        )
      v-card-actions
        v-spacer
        v-btn(color='ligth' v-if="!isMovil" text='' small @click='closeModalSetPassword()')
          | Cancelar
        v-btn(color='success' :small="!isMovil" :block ="isMovil" @click='fetchGuardarCambios(true)')
          | Confirmar
  v-card.elevation-1.pa-3
    v-skeleton-loader(v-if="!Object.keys(usuario).length" type='list-item-avatar-two-line', height="100px")
    v-list.py-0(two-line='', v-else)
      v-list-item
        .position-relative
          v-avatar.elevation-1(:size="isMovil ? 50 : 70")
            avatar-perfil(:path="usuario.foto" gradient)
          v-btn.position-absolute.floatt(fab   color="primary white--text", @click="openModalAdjuntar()"  v-if="perfil === 'sistemas' || usuarioLogged === usuario.usuario")
            v-icon edit
        v-list-item-content.ml-3
          v-list-item-title.font-weight-700(v-text='usuario.nombre', :class="isMovil ? 'font-size-17' : 'font-size-17'")
          v-list-item-subtitle( :class="isMovil ? 'font-size-12' : 'font-size-12'")
            span {{usuario.cargo}}
            span(v-if="perfil !== 'usuario-contrato' && perfil !== 'usuario-contrato'") &nbsp; ({{usuario.tipoArea}}/{{usuario.zonaGarantia}})
    .mt-4
      v-tabs(color='primary'  v-model="tab" v-if="perfil === 'sistemas' || usuarioLogged === usuario.usuario")
        v-tab(key="tab-datos") Datos
        v-tab(key="tab-reset-password") cambiar contraseña
      v-tabs-items(v-model="tab")
        v-tab-item(key="tab-datos")
          v-form.pa-2(:class="validar ? 'box-data-desktop-validar' : 'box-data-desktop'")
            v-slide-group.my-2(
              v-if="!isUsuarioEmpresa"
              v-model='usuario.entidad'
              mandatory
              show-arrows=''
            )
              v-slide-item.animated.fadeInLeft.faster(
                v-for='(n, index) in tiposUsuario'
                :value="n.value"
                :key='index'
                v-slot='{ active, toggle }'
              )
                v-card.elevation-1.ma-1.d-flex.ai-center.jc-center.text-center.fd-column(
                  :color="active ? 'primary' : 'secondary primary--text'"
                  height='85',
                  :dark="active"
                  :disabled="isUsuarioEmpresa"
                  :width="isMovil ? '100%' : '150px'"
                  @click='toggle'
                )
                  v-icon(size="30", :color="active ? 'white' : 'primary'") {{n.icon}}
                  span.font-size-13.font-weight-700 {{n.name}}
            v-row.pt-4.mt-8
              v-col(cols="12" md='3')
                .d-flex.relative.w-full
                  v-text-field(v-model='usuario.usuario' @keyup="lowercase" :disabled="validar" ref="email"  dense type="email"  label='Usuario (email)' )
                  v-fade-transition (leave-absolute='')
                    v-tooltip(top='')
                      template(v-slot:activator='{ on, attrs }')
                        v-icon(center='', size="20"  v-bind='attrs' v-on='on' :color="usuario.emailConfirmado ? 'success' : 'warning'" )
                          | {{usuario.emailConfirmado ? 'check_circle' : 'do_not_disturb_on' }}
                      small {{usuario.emailConfirmado ? 'Email verificado' : 'No verificado'}}

              v-col(cols="12" md='3' v-if="usuario.entidad === 'persona natural'")
                v-text-field( v-model='usuario.documento'  dense type="number" ref="documento"  label="Nro. Documento (DNI) *" )
              v-col(cols="12" md='3' v-if="usuario.entidad === 'empresa'")
                .d-flex
                  v-text-field(v-model='usuario.ruc' ref="ruc" dense label='Nro. RUC' counter maxlength="11"  type='number')
                  v-tooltip(top='' v-if="perfil === 'sistemas'")
                    template(v-slot:activator='{ on, attrs }')
                      v-btn.ml-4(fab, small v-bind='attrs' v-on='on'  @click="fetchGetDatosSunat()")
                        img(src="../assets/sunat.svg", width="25" height="25")
                    small Obtener datos de SUNAT
              v-col(cols="12" md='3', v-if="usuario.entidad === 'persona natural'")
                v-text-field( v-model='usuario.nombre' ref="nombreCompleto"  dense @keyup="(e) => { usuario.nombre =  e.target.value.toUpperCase() }" label="Nombre completo *" )
              v-col(cols="12" md='3' v-if="usuario.entidad === 'empresa'")
                v-text-field( v-model='usuario.razonSocial'  ref="razonsocial" dense @keyup="(e) => {  usuario.razonSocial = e.target.value.toUpperCase() }"  label="'Razon Social *" )
              v-col(cols="12" md='3')
                v-text-field( v-model='usuario.telefono' ref="telefono" type="number" counter maxlength="10" dense  label='Telefono / Celular *' )
            v-row(v-if="usuario.entidad === 'empresa'")
              v-col(cols="12" md='4')
                v-text-field( v-model='usuario.nombre'  dense  label="Nombre contacto *" )
              v-col(cols="12" md='4', )
                v-text-field( v-model='usuario.documento'  dense type="documento"  label='Nro. Documento del contacto *' )
              v-col(cols="12" md='4')
                v-text-field( v-model='usuario.cargo'   dense  label='Cargo del contacto' )
            v-row
              v-col(cols="12" md='3', v-if="usuario.entidad !== 'empresa'")
                v-text-field( v-model='usuario.cargo'   dense  label='Cargo' )
              v-col(cols="12" :md="usuario.entidad === 'empresa' ? 12 : 9")
                v-text-field( v-model='usuario.direccion'  ref="direccion" dense type="text"  label='Dirección fiscal *' )
              //- v-col(cols="12" md='3')
              //-   v-select( v-model='usuario.tipoCliente' dense :items="['Distribuidor', 'Usuario final', 'Contrato']"  label='Tipo de cliente' )
            v-row
              v-col(cols="12" md='3', )
               .d-flex
                  v-text-field(v-model='usuario.ubigeo' dense=''  label='Ubigeo' type="number", :loading="isLoadingUbigeos")
                  v-tooltip(top='')
                    template(v-slot:activator='{ on, attrs }')
                      v-btn.ml-4(fab, color="primary" small v-bind='attrs' v-on='on' :disabled="isLoadingUbigeos"  @click="fetchUbigeos(true)")
                        v-icon sync
                    small Obtener ubigeo
              v-col(cols="12" md='3')
                v-autocomplete(v-model='usuario.departamento' :items='departamentos' @change="rellenarInformacion('departamento')"  dense=''  label='Departamento')
              v-col(cols="12" md='3')
                v-autocomplete(v-model='usuario.provincia' :items='provincias'  dense='' @change="rellenarInformacion('provincia')"  label='Provincia')
              v-col(cols="12" md='3')
                v-autocomplete(v-model='usuario.distrito' :items='distritos'  dense=''  @change="rellenarInformacion('distrito')"  label='Distrito')
            .d-flex.mt-6(v-if="perfil === 'sistemas'")
              v-select(:items='perfiles' :disabled="validar" hide-details label='Perfil para el aplicativo' dense='' v-model="usuario.perfil"   item-value="nombre" item-text="nombre")
              v-select.mx-4(:items='zonasGarantia' :disabled="validar" hide-details label='Zona de garantia' dense='' v-model="usuario.zonaGarantia" )
              v-select(:items='tipoAreas' :disabled="validar" hide-details label='Tipo de area' dense='' v-model="usuario.tipoArea" )
            v-checkbox(v-model='usuario.puedeCambiarRucDeCliente' color='primary', label="Puede cambiar ruc del cliente" v-if="perfil === 'sistemas'")
              template(v-slot:label='')
                div(@click.stop="")
                  | Puede cambiar ruc del cliente

        v-tab-item(key="tab-reset-password")
          v-form.pa-2(:class="{'box-data-movil' : isMovil, 'box-data-desktop' : !validar, 'box-data-desktop-validar' : validar}")
            v-alert.my-2(icon='info' outlined text='', type='info')
              .d-flex.fd-column
                span.font-weight-700.font-size-14 Nota
                span.font-size-11  Al realizar el cambio de tu contraeña, tendras que volver a iniciar sesión
            v-text-field.pt-4(
              v-model='newPassword'
              prepend-icon='lock'
              :append-icon="!showPassword1 ? 'visibility' : 'visibility_off'"
              ref="password"
              :type="showPassword1 ? 'text' : 'password'"
              label='Ingrese una contraseña',
              @click:append='showPassword1 = !showPassword1'
              loading,
              hint="La contraseña que ingreses sera encriptada para mayor privacidad y seguridad",
              persistent-hint,
              @keyup.enter="fetchGuardarCambios()"
            )
              template(v-slot:progress='')
                v-progress-linear( :value='progress' :color='color' absolute='' height='2')
            v-text-field.pt-4(
              dense,
              v-model='newPasswordRepeat',
              prepend-icon='lock'
              :type="showPassword2 ? 'text' : 'password'",
              :append-icon="!showPassword2 ? 'visibility' : 'visibility_off'",
              label='Repita la contraseña nueva',
              @click:append='showPassword2 = !showPassword2',
              @keyup.enter="fetchGuardarCambios()"
            )
      v-card.mx-auto.position-absolute.position-active(elevation='2' absolute min-height="210px" max-height="300px" min-width="300px" max-width='300px' v-if="(perfil === 'dispatcher' || perfil === 'supervisor' || perfil === 'sistemas') && usuario.perfil === 'usuario-contrato'")
        v-card-item
          v-card-title.py-2
            strong.font-size-17 Historial de inicio
        v-divider
        v-card-text
          .d-flex.fd-column.mb-2
            span.font-size-12 Estado de email
            strong.success--text(v-if="usuario.emailConfirmado") Verificado
            strong.warning--text(v-else) No verificado
          .d-flex.fd-column
            span.font-size-12 Activación de cuenta
            .d-flex.fd-column(v-if="usuario.emailConfirmado && usuario.fechaCuentaActivada")
              strong.success--text.mb-1 Activado
              .d-flex.font-size-12.gray--text
                span El
                strong.mx-1 {{ usuario.fechaCuentaActivada | fecha }}
                span.mr-1 por
                strong  {{ usuario.nombreUsuarioCuentaActivada}}
            strong.warning--text(v-else) No activado
            v-btn.mt-2( color="info"  :block="isMovil" @click="openModalIsActiveAccount()" v-if="(perfil === 'dispatcher' || perfil === 'supervisor' || perfil === 'sistemas') && usuario.emailConfirmado && !usuario.fechaCuentaActivada ")
              small Activar cuenta
      .d-flex.align-end.-end.jc-end(v-if="perfil === 'sistemas' || usuarioLogged === usuario.usuario")
        v-spacer
        v-btn(color="success"  :block="isMovil" @click="fetchGuardarCambios()")
          small Guardar cambios
</template>

<script>
import { apiGet, apiPost, notify, apiUploadWithParams } from '../util/general'
import adjuntarArchivos from '@/components/c_adjuntar_archivos'
import avatarPerfil from '@/components/c_avatar_perfil'
import moment from 'moment'
export default {
  name      : 'View_user_profile',
  props     : {
    username : {
      type: String
    },
    validar : {
      type   : Boolean,
      default: true
    }
  },
  components: {
    'adjuntar-archivos': adjuntarArchivos,
    'avatar-perfil'    : avatarPerfil
  },
  data () {
    return {
      currentPassword  : '',
      newPassword      : '',
      newPasswordRepeat: '',
      usuario          : {},
      showPassword     : false,
      showPassword1    : false,
      showPassword2    : false,
      perfil           : localStorage.getItem('perfil'),
      usuarioLogged           : localStorage.getItem('username'),
      tab              : 0,
      isSetPassword    : false,
      isUploadAvatar   : false,
      isActiveAccount   : false,
      file             : null,
      isUsuarioEmpresa : false,
      perfiles         : [
        {
          nombre : 'usuario',
          esUnPerfilDeLaEmpresa : false
        },
        {
          nombre : 'usuario-contrato',
          esUnPerfilDeLaEmpresa : false
        },
        {
          nombre : 'tecnico taller',
          esUnPerfilDeLaEmpresa : true
        },
        // {
        //   nombre : 'tecnico',
        //   esUnPerfilDeLaEmpresa : false
        // },
        {
          nombre : 'supervisor',
          esUnPerfilDeLaEmpresa : true
        },
        {
          nombre : 'recepcion',
          esUnPerfilDeLaEmpresa : true
        },
        {
          nombre : 'dispatcher',
          esUnPerfilDeLaEmpresa : true
        },
        {
          nombre : 'sistemas',
          esUnPerfilDeLaEmpresa : true
        }
      ],
      departamentos: [],
      provincias   : [],
      distritos    : [],
      ubigeos      : [],
      zonasGarantia: [
        'lima',
        'arequipa',
        'sin asignacion'
      ],
      tipoAreas             : [
        'campo',
        'taller',
        'sin asignacion'
      ],
      isLoadingDepartamentos: false,
      isLoadingProvincias   : false,
      isLoadingDistritos    : false,
      isLoadingActivating    : false,
      isLoadingUbigeos      : false,
      tiposUsuario          : [
        {
          name : 'Persona Natural',
          value: 'persona natural',
          icon : 'person'
        },
        {
          name : 'Empresa',
          value: 'empresa',
          icon : 'apartment'
        }
      ]
    }
  },
  created () {
    var vm = this
    vm.fetchUbigeos(false, err => {
      if (err) notify(vm, 'error', 'Error', 'Ingrese un numero de RUC')
      vm.fetchUsuario()
    })
  },
  filters : {
    fecha: function (value) {
      return moment(value).format('DD/MM/YYYY HH:MM')
    }
  },
  computed: {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    },
    progress () {
      var vm = this
      return Math.min(100, vm.newPassword.length * 16.7)
    },
    color () {
      var vm = this
      return ['error', 'warning', 'success'][Math.floor(vm.progress / 40)]
    }
  },
  methods: {
    lowercase (e) {
      var vm = this
      vm.usuario.usuario = e.target.value.toLowerCase();
    },
    validateEmail (email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    },
    fetchGetDatosSunat () {
      var vm = this

      if (!vm.usuario.ruc) {
        notify(vm, 'error', 'Error', 'Ingrese un numero de RUC')
        vm.$refs.ruc.focus()
        return;
      }

      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo información de SUNAT' })
      var obj = {
        ruc: vm.usuario.ruc
      }
      apiGet(vm, '/cliente/sunat', obj, function (data) {
        if (data.empresa) {
          vm.usuario.direccion = data.empresa.direccion
          vm.usuario.razonSocial = data.empresa.nombre_o_razon_social
        }
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, () => {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    getImagenToProfile (file = {}) {
      var vm = this
      var objFile = file ? file[0] : {}
      vm.fetchUploadFile(objFile, (err, response) => {
        if (err) {
          notify(vm, 'error', 'Error', err.message)
          return
        }
        vm.file = null
        vm.usuario.foto = response.ruta
        vm.fetchActualizarFotoPerfil(err => {
          if (err) {
            notify(vm, 'error', 'Error', err.message)
            return
          }

          vm.$store.dispatch('transaccion', { isProceso : false })
          vm.closeModalAdjuntar()
          notify(vm, 'success', 'Exito', 'Tu foto de perfil se actualizo correctamente')
        })
      })
    },
    openModalAdjuntar () {
      var vm = this
      vm.isUploadAvatar = true
    },
    closeModalAdjuntar () {
      var vm = this
      vm.isUploadAvatar = false
    },
    openModalIsActiveAccount () {
      var vm = this
      vm.isActiveAccount = true
    },
    closeModalIsActiveAccount () {
      var vm = this
      vm.isActiveAccount = false
    },
    closeModalSetPassword () {
      var vm = this
      vm.isSetPassword = false
      vm.currentPassword = ''
    },
    redirectProteccion () {
      // var vm = this
      window.open('https://www.minjus.gob.pe/wp-content/uploads/2013/04/LEY-29733.pdf', '_blanck')
    },
    rellenarInformacion (tipo) {
      var vm = this
      if (tipo === 'departamento') {
        vm.provincias = []
        vm.usuario.provincia = ''
        vm.distritos  = []
        vm.usuario.distrito = ''
      } else if (tipo === 'provincia') {
        vm.distritos  = []
        vm.usuario.distrito = ''
      }

      for (var i = 0; i < vm.ubigeos.length; i++) {
        if (tipo === 'departamento') {
          if (vm.usuario.departamento === vm.ubigeos[i].departamento) {
            vm.provincias.push(vm.ubigeos[i].provincia)
          }
        } else if (tipo === 'provincia') {
          if (vm.usuario.provincia === vm.ubigeos[i].provincia) {
            vm.distritos.push(vm.ubigeos[i].distrito)
          }
        }
      }

      if (vm.usuario.departamento && vm.usuario.provincia && vm.usuario.distrito) {
        vm.usuario.ubigeo = vm.ubigeos.find(e => e.descripcion === `${vm.usuario.departamento}-${vm.usuario.provincia}-${vm.usuario.distrito}`).ubigeo
      } else vm.usuario.ubigeo = ''
    },
    fetchUbigeos (ingresoUbigeo, callback) {
      var vm  = this
      vm.isLoadingUbigeos = true
      var obj = {
        codigo: vm.usuario.ubigeo
      }
      apiGet(vm, '/ubigeo/obtener', obj, function (data) {
        if (ingresoUbigeo) {
          var lista = data.lista[0]
          for (var j = 0; j < vm.ubigeos.length; j++) {
            if (lista.departamento === vm.ubigeos[j].departamento) {
              vm.provincias.push(vm.ubigeos[j].provincia)
            }

            if (lista.provincia === vm.ubigeos[j].provincia) {
              vm.distritos.push(vm.ubigeos[j].distrito)
            }
          }
          vm.usuario.departamento = lista.departamento
          vm.usuario.provincia    = lista.provincia
          vm.usuario.distrito     = lista.distrito
        } else {
          vm.ubigeos = data.lista
          for (var i = 0; i < data.lista.length; i++) {
            vm.departamentos.push(data.lista[i].departamento)
          }
        }
        callback && callback()
      }, function (error) {
        callback ? callback(error) :  notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoadingUbigeos = false
      })
    },
    fetchUsuario () {
      var vm              = this
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo tus datos' })
      var obj             = {
        usuario: vm.username
      }
      apiGet(vm, '/usuario/obtener', obj, function (data) {
        vm.usuario = data.lista[0]
        vm.usuario.puedeCambiarRucDeCliente = vm.usuario.puedeCambiarRucDeCliente === 1
        vm.usuario.usuarioAntiguo = vm.usuario.usuario
        var perfilEncontrado = vm.perfiles.find(e => e.nombre === vm.usuario.perfil)
        vm.isUsuarioEmpresa  = perfilEncontrado.esUnPerfilDeLaEmpresa
        for (var i = 0; i < vm.ubigeos.length; i++) {
          if (vm.usuario.departamento) {
            if (vm.usuario.departamento === vm.ubigeos[i].departamento) {
              vm.provincias.push(vm.ubigeos[i].provincia)
            }
          }

          if (vm.usuario.provincia) {
            if (vm.usuario.provincia === vm.ubigeos[i].provincia) {
              vm.distritos.push(vm.ubigeos[i].distrito)
            }
          }
        }
        if (!vm.usuario.entidad) vm.usuario.entidad = 'persona natural'
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetchGuardarCambios (isNotify = false, callback) {
      var vm = this
      var obj = {
        usuario                    : vm.usuario.usuario,
        usuarioAntiguo             : vm.usuario.usuario,
        nombre                     : vm.usuario.nombre,
        telefono                   : vm.usuario.telefono,
        cargo                      : vm.usuario.cargo,
        direccion                  : vm.usuario.direccion,
        // tipoCliente                : vm.usuario.tipoCliente,
        entidad                    : vm.usuario.entidad,
        documento                  : vm.usuario.documento,
        razonSocial                : vm.usuario.razonSocial,
        departamento               : vm.usuario.departamento,
        provincia                  : vm.usuario.provincia,
        distrito                   : vm.usuario.distrito,
        ubigeo                     : vm.usuario.ubigeo,
        ruc                        : vm.usuario.ruc,
        perfil                     : vm.usuario.perfil,
        zonaGarantia                : vm.usuario.zonaGarantia,
        tipoArea                   : vm.usuario.tipoArea,
        currentPassword            : vm.currentPassword,
        puedeCambiarRucDeCliente            : vm.usuario.puedeCambiarRucDeCliente ? 1 : 0,
        aceptaPoliticasDeprivacidad: vm.usuario.aceptaPoliticasDeprivacidad ? 1 : 0
      }

      // Validamos
      if (!vm.usuario.usuario) {
        notify(vm, 'error', 'Error', 'Por favor no deje el email en blanco')
        vm.$refs.email.focus()
        vm.closeModalSetPassword()
        return;
      } else {
        if (!vm.validateEmail(vm.usuario.usuario)) {
          notify(vm, 'error', 'Error', 'El email no cumple con el formato adecuado')
          vm.$refs.email.focus()
          vm.closeModalSetPassword()
          return
        }
      }

      if (vm.validar) {
        if (vm.usuario.entidad === 'empresa' && !vm.usuario.ruc && !vm.isUsuarioEmpresa) {
          notify(vm, 'error', 'Error', 'Por favor ingrese el numero de RUC')
          vm.$refs.ruc.focus()
          vm.closeModalSetPassword()
          return
        }

        if (!vm.usuario.documento && !vm.isUsuarioEmpresa) {
          notify(vm, 'error', 'Error', 'Por favor no deje el documento en blanco')
          vm.$refs.documento.focus()
          vm.closeModalSetPassword()
          return;
        }

        if (vm.usuario.entidad !== 'empresa' && !vm.usuario.nombre && !vm.isUsuarioEmpresa) {
          notify(vm, 'error', 'Error', 'Por favor no deje el nombre en blanco')
          vm.$refs.nombreCompleto.focus()
          vm.closeModalSetPassword()
          return;
        }

        if (vm.usuario.entidad === 'empresa' && !vm.usuario.razonSocial) {
          notify(vm, 'error', 'Error', 'Por favor no deje la razon social en blanco')
          vm.$refs.razonsocial.focus()
          vm.closeModalSetPassword()
          return;
        }

        if (!vm.usuario.telefono && !vm.isUsuarioEmpresa) {
          notify(vm, 'error', 'Error', 'Por favor no deje el telefono en blanco')
          vm.$refs.telefono.focus()
          vm.closeModalSetPassword()
          return;
        }

        if (!vm.usuario.direccion && !vm.isUsuarioEmpresa) {
          notify(vm, 'error', 'Error', 'Por favor no deje la direccion en blanco')
          vm.$refs.direccion.focus()
          vm.closeModalSetPassword()
          return;
        }
      }

      if (vm.newPassword) {
        if (vm.newPassword !== vm.newPasswordRepeat) {
          notify(vm, 'error', 'Error', 'Las contraseñas nuevas ingresadas no coinciden, por favor verifique')
          return;
        } else {
          obj.newPassword     = vm.newPassword
          obj.currentPassword = vm.currentPassword
        }
      }

      if (!vm.currentPassword) {
        if (isNotify) {
          notify(vm, 'error', 'Error', 'Por favor ingrese su contraseña actual')
          vm.$refs.currentPassword.focus()
          return
        } else {
          if (!vm.validar) vm.currentPassword = 'tukutin#40'
          vm.isSetPassword = true
          return
        }
      }

      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Actualizando tus datos' })

      apiPost(vm, '/usuario/actualizar', obj, function (data) {
        if (vm.validar) {
          localStorage.setItem('token', data.token)
          localStorage.setItem('perfil', data.datos.perfil)
          localStorage.setItem('username', data.datos.usuario)
          localStorage.setItem('codigoCliente', data.datos.codigoCliente)
          localStorage.setItem('nombre', data.datos.nombre)
          localStorage.setItem('razonSocial', data.datos.razonSocial)
          localStorage.setItem('entidad', data.datos.entidad)
        }
        if (callback) {
          callback(null)
        } else {
          notify(vm, 'success', 'Exito', 'Datos guardados correctamente')
          vm.clearForm()
        }
      }, function (error) {
        callback ? callback(error) : notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', {isProceso : false})
      })
    },
    fetchActualizarFotoPerfil (callback) {
      var vm = this
      var obj = {
        username: vm.usuario.usuario,
        foto    : vm.usuario.foto
      }
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Actualizando foto de perfil' })
      apiPost(vm, '/usuario/actualizar/foto', obj, function (data) {
        callback(null, data)
      }, function (error) {
        callback(error)
      }, function () {
        vm.$store.dispatch('transaccion', {isProceso : false})
      })
    },
    fetchActivateAccount () {
      var vm = this
      vm.isLoadingActivating = true
      var obj = {
        email: vm.usuario.usuario
      }
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Activando cuenta' })
      apiPost(vm, '/usuario/activar/cuenta', obj, function (data) {
        vm.closeModalIsActiveAccount()
        notify(vm, 'success', 'Exito', 'La cuenta fue activada correctamente')
        vm.fetchUsuario()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', {isProceso : false})
        vm.isLoadingActivating = false
      })
    },
    clearForm () {
      var vm = this
      vm.currentPassword = ''
      vm.newPassword = ''
      vm.newPasswordRepeat = ''
      vm.closeModalSetPassword()
    },
    fetchUploadFile (file, callback) {
      var vm = this
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Actualizando imagen de perfil' })
      var fd = new FormData()
      var apiUploadRoute = process.env.API_UPLOAD_ROUTE
      var url = `${apiUploadRoute}/upload`
      fd.append('file', file)
      var params = {
        carpeta: 'img-perfiles',
        usuario: localStorage.getItem('usuario')
      }

      apiUploadWithParams(vm, url, fd, params,  res => {
        callback(null, res)
      }, err => {
        vm.$store.dispatch('transaccion', { isProceso : false })
        callback(err)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.floatt
  right: -5px;
  bottom: -7px;
.box-data-movil
  max-height: calc(100vh - 270px) !important
  overflow-y auto
  overflow-x hidden
.box-data-desktop-validar
  max-height: calc(100vh - 205px)
  overflow-y auto
  overflow-x hidden
.box-data-desktop
  max-height: calc(100vh - 332px)
  overflow-y auto
  overflow-x hidden
.position-active
  right  10px
  top 10px
</style>



// WEBPACK FOOTER //
// c_usuario_form_editar_datos.vue?3794cfa5